export const aside = {
  groups: {
    general: 'عام',
    management: 'إدارة',
    planning: 'تخطيط',
    configuration: 'إعدادات',
    account: 'حساب'
  },
  routes: {
    home: 'الرئيسية',
    dashboard: 'لوحة التحكم',
    activities: 'النشاطات',
    users: 'المستخدمون',
    profile: 'الملف الشخصي',
    testStore: 'اختبار المتجر',
    products: 'المنتجات',
    categories: 'الفئات',
    customers: 'العملاء',
    sales: 'المبيعات',
    stockMovements: 'حركات المخزون',
    cashMovements: 'حركات الصندوق',
    settings: 'الإعدادات',
    saleModels: 'نماذج البيع',
    tables: 'الطاولات',
    appointments: 'المواعيد',
    commandes: 'الطلبات',
    activitySettings: 'إعدادات النشاط',
    pos: 'نقطة البيع',
    payments: 'المدفوعات',
    usersManagement: 'إدارة المستخدمين',
    approvisionnements: 'التوريدات',
    quickAccess: 'الوصول السريع'
  }
}; 